import React from "react";

const AddOnlineMerchant = () => {
  return (
    <div>
      <div>Add Online Merchant</div>
    </div>
  );
};

export default AddOnlineMerchant;
